import { render, staticRenderFns } from "./loyalty-reward-modal.vue?vue&type=template&id=152b73cd&scoped=true&"
import script from "./loyalty-reward-modal.ts?vue&type=script&lang=ts&"
export * from "./loyalty-reward-modal.ts?vue&type=script&lang=ts&"
import style0 from "./loyalty-reward-modal.scss?vue&type=style&index=0&id=152b73cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b73cd",
  null
  
)

component.options.__file = "loyalty-reward-modal.vue"
export default component.exports